import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {OrderEmailScheduleModel } from "@TKCCP/Types/ApiModels";
import { AddOrderReminder, OrderReminderApiParameter } from "@TKCCP/Services/tkccpOrderReminderService";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess & HasOnError<string>,
    OrderReminderApiParameter,
    OrderEmailScheduleModel,
    { orderEmailScheduleModel: OrderEmailScheduleModel }
>;



export const CallAddOrderReminder= (model : OrderReminderApiParameter) => {
 
    try {
       const result = AddOrderReminder(model);
    } catch (error) {
        }
};

